import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const kitchenAreaTagManager = createRangeTagManager({
  jsonQueryKey: 'kitchen',
  template: 'Площадь кухни %s м²',
  id: 'kitchenArea',
});
